module.exports = __webpack_public_path__ + "static/blog26-b51831cf7aadb3908046b03b446a82b6.png";